// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment-editor-inline{display:block;position:relative}.comment-editor-inline .thread-editor-visibility-options{border-top:1px solid #c6c6c6}.comment-editor-inline .thread-editor-visibility-options .select2-selection{border:none !important}", ""]);
// Exports
module.exports = exports;
